export default __webpack_public_path__ + "static/media/check-icon.bdf7e227.svg";